// Note: The first file of a module here, must also register the module

import "./create-dashboard.component";
import "./dashboard.component";
import "./dashboard-actions.component";
import "./dashboard-filters.component";
import "./dashboards-page.component";
import "./unsaved-changes-dialog.component";
import "./widget/widget.component";
import "./widget/create-widget.component";
import "./widget/create-widget-button.component";
import "./widget/duplicate-widget.component";
import "./widget/fullscreen-widget.component";
import "./widget/style/widget-style-form.component";
import "./widget/style/widget-color-dropdown.component";
import "./widget/filter/widget-filter-form.component";
import "./widget/filter/widget-filter-dialog.component";
import "./widget/filter/widget-filter-lists-dialog.component";
import "./widget/filter/widget-filter-divisions-dialog.component";
import "./widget/filter/widget-filter-users-teams-dialog.component";
